(() => {
  const STORAGE_KEY = 'gqAccessibility';
  const root = document.documentElement;

  function init() {
    if (document.querySelector('.gq-a11y-trigger')) return;

    const es = (root.lang || '').toLowerCase().startsWith('es');
    const copy = es ? {
      trigger: 'Accesibilidad',
      title: 'Preferencias de accesibilidad',
      description: 'Ajusta el sitio para facilitar la lectura, aumentar el contraste o reducir el movimiento. Tus preferencias se guardan en este dispositivo.',
      largeText: 'Texto más grande',
      largeTextHint: 'Aumenta el tamaño del texto y de los controles.',
      highContrast: 'Alto contraste',
      highContrastHint: 'Refuerza texto, bordes y estados importantes.',
      reducedMotion: 'Movimiento reducido',
      reducedMotionHint: 'Reduce animaciones y transiciones no esenciales.',
      close: 'Cerrar'
    } : {
      trigger: 'Accessibility',
      title: 'Accessibility preferences',
      description: 'Adjust the store for easier reading, stronger contrast, or less motion. Your preferences are saved on this device.',
      largeText: 'Larger text',
      largeTextHint: 'Increase text and control sizing.',
      highContrast: 'High contrast',
      highContrastHint: 'Strengthen text, borders, and important states.',
      reducedMotion: 'Reduced motion',
      reducedMotionHint: 'Reduce non-essential animation and transitions.',
      close: 'Close'
    };

    let state = { largeText: false, highContrast: false, reducedMotion: false };
    let hadSavedState = false;
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        state = { ...state, ...JSON.parse(saved) };
        hadSavedState = true;
      }
    } catch (_) {}
    if (!hadSavedState && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      state.reducedMotion = true;
    }

    const apply = () => {
      root.classList.toggle('gq-a11y-large-text', Boolean(state.largeText));
      root.classList.toggle('gq-a11y-high-contrast', Boolean(state.highContrast));
      root.classList.toggle('gq-a11y-reduced-motion', Boolean(state.reducedMotion));
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (_) {}
    };
    apply();

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'gq-a11y-trigger';
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', 'gq-a11y-panel');
    trigger.setAttribute('aria-label', copy.trigger);
    trigger.innerHTML = '<span aria-hidden="true" style="font-weight:800;font-size:16px">Aa</span><span class="gq-a11y-trigger__label">' + copy.trigger + '</span>';

    const backdrop = document.createElement('div');
    backdrop.className = 'gq-a11y-backdrop';
    backdrop.setAttribute('aria-hidden', 'true');

    const panel = document.createElement('section');
    panel.id = 'gq-a11y-panel';
    panel.className = 'gq-a11y-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-labelledby', 'gq-a11y-title');
    panel.setAttribute('aria-describedby', 'gq-a11y-description');
    panel.setAttribute('tabindex', '-1');

    panel.innerHTML = '<div class="gq-a11y-panel__header"><div><h2 id="gq-a11y-title">' + copy.title + '</h2><p id="gq-a11y-description">' + copy.description + '</p></div><button type="button" class="gq-a11y-close" aria-label="' + copy.close + '">×</button></div><div class="gq-a11y-options"></div>';

    const options = panel.querySelector('.gq-a11y-options');
    const definitions = [
      ['largeText', copy.largeText, copy.largeTextHint],
      ['highContrast', copy.highContrast, copy.highContrastHint],
      ['reducedMotion', copy.reducedMotion, copy.reducedMotionHint]
    ];

    definitions.forEach(([key, label, hint]) => {
      const row = document.createElement('div');
      row.className = 'gq-a11y-option';
      const text = document.createElement('div');
      text.className = 'gq-a11y-option__copy';
      text.innerHTML = '<strong>' + label + '</strong><span>' + hint + '</span>';
      const control = document.createElement('button');
      control.type = 'button';
      control.className = 'gq-a11y-switch';
      control.setAttribute('role', 'switch');
      control.setAttribute('aria-label', label);
      control.setAttribute('aria-checked', String(Boolean(state[key])));
      control.setAttribute('aria-pressed', String(Boolean(state[key])));
      control.addEventListener('click', () => {
        state[key] = !state[key];
        control.setAttribute('aria-checked', String(Boolean(state[key])));
        control.setAttribute('aria-pressed', String(Boolean(state[key])));
        apply();
      });
      row.append(text, control);
      options.appendChild(row);
    });

    const closeButton = panel.querySelector('.gq-a11y-close');
    let lastFocus = null;
    const open = () => {
      lastFocus = document.activeElement;
      backdrop.dataset.open = 'true';
      panel.dataset.open = 'true';
      trigger.setAttribute('aria-expanded', 'true');
      closeButton.focus();
    };
    const close = () => {
      backdrop.dataset.open = 'false';
      panel.dataset.open = 'false';
      trigger.setAttribute('aria-expanded', 'false');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      else trigger.focus();
    };

    trigger.addEventListener('click', open);
    closeButton.addEventListener('click', close);
    backdrop.addEventListener('click', close);
    panel.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = Array.from(panel.querySelectorAll('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])')).filter((el) => !el.disabled);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    document.body.append(backdrop, panel, trigger);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
